const locale = {
  'importModal.title': 'استيراد دفعة',
  'importModal.button.upload': 'رفع ملف',
  'importModal.message.parseError': 'فشل في تحليل الملف',
  'importModal.table.updatedFieldName': 'عمود قابل للتحديث',
  'importModal.table.fileColumnTitle': 'عمود الملف',
  'importModal.table.previewValue': 'معاينة البيانات',
  'importModal.table.defaultValue': 'القيمة الافتراضية',
  'importModal.select.placeholder': 'الرجاء الاختيار',
  'importModal.input.placeholder': 'الرجاء الإدخال',
  'importModal.button.downloadTemplate': 'تحميل القالب',
};

export default locale;
